import { CSSProperties } from 'react';

interface Props {
  viewBoxProp?: string;
  styleProp?: CSSProperties;
  color: string;
}

const MouthIcon = ({ viewBoxProp, styleProp, color }: Props) => {
  const viewBox = viewBoxProp ?? "0 0 35 35";
  const style = styleProp ?? { width: '100%', height: 'auto' };

  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox={viewBox} style={style}>
      <path d="M30.98,3.26c-0.63-0.35-1.4-0.34-2.02,0.03c-3.46,2.09-7.42,3.2-11.46,3.2S9.49,5.38,6.04,3.29
        C5.42,2.92,4.65,2.9,4.02,3.26C3.39,3.61,3,4.28,3,5v13.49c0,2.66,0.73,5.26,2.11,7.54C7.72,30.33,12.47,33,17.5,33
        s9.78-2.67,12.39-6.98c1.38-2.28,2.11-4.88,2.11-7.53V5C32,4.28,31.61,3.61,30.98,3.26z M7,8.29c6.6,2.89,14.4,2.89,21,0v10.21
        c0,0.3-0.04,0.61-0.06,0.91l-0.5-0.15c-3.4-1.01-7.01-0.48-9.94,1.4c-2.93-1.88-6.54-2.42-9.94-1.4l-0.5,0.15
        C7.04,19.1,7,18.79,7,18.49V8.29z M17.5,29c-3.7,0-7.05-1.89-8.97-5.05c-0.14-0.23-0.24-0.47-0.36-0.71l0.54-0.16
        c2.62-0.78,5.42-0.19,7.5,1.57c0.02,0.02,0.04,0.03,0.06,0.04c0.04,0.03,0.08,0.05,0.12,0.08c0.08,0.05,0.15,0.1,0.23,0.14
        c0.04,0.02,0.08,0.04,0.12,0.06c0.09,0.04,0.18,0.06,0.27,0.09c0.04,0.01,0.07,0.02,0.11,0.03c0.13,0.03,0.26,0.04,0.39,0.04
        c0,0,0,0,0,0s0,0,0,0c0.13,0,0.26-0.02,0.39-0.04c0.04-0.01,0.07-0.02,0.11-0.03c0.09-0.02,0.18-0.05,0.27-0.09
        c0.04-0.02,0.08-0.04,0.12-0.06c0.08-0.04,0.16-0.09,0.23-0.14c0.04-0.03,0.08-0.05,0.12-0.08c0.02-0.01,0.04-0.02,0.06-0.04
        c2.08-1.77,4.89-2.35,7.5-1.57l0.54,0.16c-0.12,0.24-0.23,0.48-0.36,0.7C24.55,27.11,21.2,29,17.5,29z"
        fill={color} />
    </svg>
  );
}

export default MouthIcon;
